import { Controller } from "@hotwired/stimulus"

import "../plugins/jquery.bootstrap.wizard"
import Swal from "sweetalert2";
import { advanceWizardStep, resetWizardStepRequest, wizardDescriptionRequest } from "../peaq/wizard"
// import "../plugins/argon/multistep-form"

// import "../plugins/"
// require("../plugins/wizard");

// Connects to data-controller="wizard"
export default class extends Controller {

  connect() {
    $('#wizard').bootstrapWizard()

    this.resetOnWizardClose = (event) => {
      if (event.target !== this.element) return

      resetWizardStepRequest()
    }

    $(this.element).on('hidden.bs.modal', this.resetOnWizardClose)
  }

  disconnect() {
    $(this.element).off('hidden.bs.modal', this.resetOnWizardClose)
  }

  productChange(event) {
    event.preventDefault();

    wizardDescriptionRequest($(event.target).data().updateUrl, {
      product_id: $("#product_select")[0].value
    });
  }

  productNext(){
    advanceWizardStep($('#products-form'), 1);
  }

  licenseRowFailed() {
    showFlash('danger', $('#wizard').data('license-row-request-failed-message'));
  }

  findAllSelectedCheckboxes(checkboxes) {
    return Array.from(checkboxes).filter(
      checkbox => checkbox.checked,
    );
  }

}
